import React from 'react';

interface IProps {
  children?: any;
  when: boolean;
}

export const Exist: React.FC<IProps> = ({ children, when }) => <>{when ? children : null}</>; // eslint-disable-line
